import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Activity } from '@user/features/Activity/typings'
import { useData } from '../hooks'

type Props = {
  activity?: Activity
}

export function EditActivityStatusFormDetails(props: Props) {
  const { activity } = props

  const { owner, activityType, startDate, dueDate } = useData(activity!)

  return (
    <Box>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          Type:
        </Typography>{' '}
        {activityType?.name}
      </Typography>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          Owner:
        </Typography>{' '}
        {owner}
      </Typography>
      <Typography variant="body2" mt={1}>
        <Typography variant="subtitle2" component="span">
          Start Date:
        </Typography>{' '}
        {startDate}
      </Typography>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          Due Date:
        </Typography>{' '}
        {dueDate}
      </Typography>
      {activity && activity.description && (
        <Typography variant="body2" mt={1}>
          <Typography variant="subtitle2" component="span">
            Description:
          </Typography>{' '}
          {activity?.description}
        </Typography>
      )}
    </Box>
  )
}
